import React,{ useEffect, useState }  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { useToken } from '../../../utilities/hooks';
import {Button, IconButton, InputLabel, Tooltip, Typography} from '@material-ui/core';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineOppositeContent, TimelineDot } from '@material-ui/lab';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import { useTranslation } from 'react-i18next';
import {showAlertSnackbar} from "../../../reducers/uiSlice";
import UniDialog from '../../Common/UniDialog';
import {useDispatch} from "react-redux";
import {Refresh, Remove, RemoveCircleSharp, RemoveFromQueue, Restore, UndoRounded, UndoSharp, UndoTwoTone} from "@material-ui/icons";
import {assignOrderToDriver} from "../../../actions/mmActions";
import {operationLog} from "../../../actions/commonAction";
import {revertLastPathState} from "../../../actions/editOrderActions";
import {getUserPreference} from "../../../utilities/common";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import _ from 'lodash';
const READ_ONLY = 300;
const  DISABLE_TIME = process.env.REACT_APP_STATE_DISABLE_TIME ||15;
const useStyles = makeStyles((theme)=> ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '100%',
      },
    oppositeContent: {
        flex: 0,
        padding:0,
    },
}))

export default function RouteTimeline(props) {
    const { orderRouteHistoryList  } = props;
    const { orderTrackingInfo } = props;
    const { orderBasicInfo } = props;
    const classes = useStyles();
    const {t} = useTranslation('editOrder');
    const dispatch = useDispatch();
    const userPref = getUserPreference();
    const [orderRoutList, setOrderRoutList] = useState(orderRouteHistoryList);
    const [stateError, setStateError] = useState("");
    const [revertPathDialogOpen, setRevertPathDialogOpen] = useState(false);
    const [revertPathTimeOut, setRevertPathTimeOut] = useState(false);
    const REVERT_SERVICE_DISABLED_STATUS_LIST = [190,192,198,199,195,200,202,255,232];

    const tokenContents = useToken();
    const isReadOnly = tokenContents.uiAbilities.includes(READ_ONLY);
    const handleRevertPathOpen = () => {

        setRevertPathDialogOpen(true);
    }

    useEffect(() => {
        if (orderRouteHistoryList) {

            setOrderRoutList(orderRouteHistoryList);
        }
    }, [orderRouteHistoryList])

    function timeZoneConvertDateTime(status, timestamp, localtime, localTimeZone) {
        let dateTime = '';
        let timeZone = '';
        if(localtime || localTimeZone) {
            dateTime = localtime;
            timeZone = localTimeZone;
        } else if(status === 198 || status === 192) {
            // Use CST timezone when status === 198 / 192 by GV
            // Display "Local Time" for timezone
            dateTime = moment(moment.unix(timestamp).utc()).utcOffset("-06:00").format("YYYY-MM-DD HH:mm:ss");
            timeZone = 'Local Time';
        } else if(status === 190) {
            // Use UTC timezone when status === 190 and not display timezone
            dateTime = moment.unix(timestamp).utc().format("YYYY-MM-DD HH:mm:ss")
            timeZone = '';
        } else {
            // For other status with no localtime / localTimeZone
            // Use UTC time and UTC timezone
            dateTime = moment.unix(timestamp).utc().format("YYYY-MM-DD HH:mm:ss")
            timeZone = 'Coordinated Universal Time';
        }
        return {
            dateTime: dateTime,
            timeZone: timeZone
        }
    }


    return (
        <React.Fragment>
            <Timeline>                
            {
                orderRoutList.map((item,index)=>(
                    <TimelineItem key={item+index}>
                        <TimelineOppositeContent
                            className={classes.oppositeContent}
                            color="textSecondary"
                        >
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                        <TimelineDot />
                        <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                            <Paper elevation={3} className={classes.paper}>
                                <Typography variant="body2">
                                    {item.code}: {item.pathInfo}
                                </Typography>
                                <Typography variant="body2">
                                {
                                    timeZoneConvertDateTime(item.code, item.pathTime, item.dateTime.localTime, item.dateTime.timezone).dateTime
                                }
                                </Typography>
                                <Typography variant="body2">
                                {
                                    timeZoneConvertDateTime(item.code, item.pathTime, item.dateTime.localTime, item.dateTime.timezone).timeZone
                                }
                                </Typography>
                                {
                                    !_.isNil(item.distance_to_delivery) &&
                                    <Typography variant="body2">
                                        {t('distance')}: {item.distance_to_delivery} {t('meter')}
                                    </Typography>
                                }
                                <Typography
                                    variant="body2"
                                    style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap',}}
                                >
                                    <LocalShippingIcon/> 
                                    <span>
                                        {
                                            (item.staff_id && Number(item.staff_id) !== 666) ? 
                                                item.staff_id : 
                                                (item.operator ? item.operator : "N/A")
                                        }
                                    </span>
                                    {
                                        index === orderRoutList.length - 1 &&

                                        <div style={{display: 'flex', marginLeft: 70, alignItems: 'center'}}>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                disabled={REVERT_SERVICE_DISABLED_STATUS_LIST.includes(item.code) || revertPathTimeOut||isReadOnly|| checkDisableTime(item) || orderTrackingInfo.second_delivery_sn}
                                                color="primary"
                                                onClick={handleRevertPathOpen}
                                                className={classes.buttonStyle}
                                            >{t('tip_undo')}</Button>
                                        </div> 
                                    }
                                </Typography>
                            </Paper>
                        </TimelineContent>
                    </TimelineItem>
                ))
            }                        
            </Timeline>
            <UniDialog
                title={t('dialog_revert_path_title')}
                fullWidth
                open={revertPathDialogOpen}
                onClose={()=>{
                    setRevertPathDialogOpen(false);
                }}
                autoClose={false}
                onFinish={()=>{
                    revertCurrentOrderPath(orderTrackingInfo.order_id);
                    setRevertPathDialogOpen(false);
                }}
                contentStyle={{overflow: 'hidden'}}
            >
                <div style={{marginBottom:20}}>
                    {t('revert_path_orders_id')}
                    {
                        orderTrackingInfo?.tno
                    }
                </div>
                <div style={{marginBottom:20}}>
                    {t('driver_id')}: {orderBasicInfo?.shipping_staff_id}
                </div>
                <div style={{marginBottom:20}}>
                    {t('revert_path_order_code')}
                    {
                        orderTrackingInfo?.state
                    }
                </div>
            </UniDialog>
        </React.Fragment>

    )

    function revertCurrentOrderPath(orderId) {

        dispatch(revertLastPathState(orderId))
            .then(data => {

                if (data.status === "SUCCESS") {
                    dispatch(showAlertSnackbar({message: data.data, type: 'success'}))

                    setOrderRoutList(orderRoutList.slice(0, -1))
                    orderRouteHistoryList.splice(-1)

                } else
                    dispatch(showAlertSnackbar({message: data.data, type: 'warning'}))
            }).catch(error => {
            if (error.message == "Time exceeds, revert failed") {
                setRevertPathTimeOut(true)
            }
            dispatch(showAlertSnackbar({title: 'Revert Order', message: error.message}))
        })

    }

    function checkDisableTime(item) {
        if (!_.isNil(item.dateTime.localTime) && !_.isNil(item.dateTime.timezone)) {

            let stateTime = momentTimeZone.tz(item.dateTime.localTime, item.dateTime.timezone).unix();
            let currentTime = momentTimeZone().unix();
            let diff = currentTime - stateTime;
            if (diff <= DISABLE_TIME * 60) {
                return false;
            }
        }
        return true;
    }
}

RouteTimeline.defaultProps = {
    orderRouteHistoryList: []
}